import { Button, Col, Row, Space } from 'antd';
import Table, { ColumnsType } from 'antd/lib/table';
import moment from 'moment';
import 'moment/locale/ko';
import styled from 'styled-components';
import { BidProposal } from '../../modules/bid-chances';
import { priceToString } from '../../util/utils';
import { styledTable } from '../styled/mixin';
import Link from 'antd/lib/typography/Link';

const StyledDiv = styled.div`
  ${styledTable}
`;

interface BidProposalListComponentProps {
  bidProposals: BidProposal[];
  isSovIncluded: boolean;
  moveToBidProposalDetailPage: (bidProposalId: number) => void;
  downloadFile: (attachFileId: string, fileName: string) => void;
  openBidProposalCreateModal: () => void;
}

function BidProposalListComponent({
  bidProposals,
  isSovIncluded,
  moveToBidProposalDetailPage,
  downloadFile,
  openBidProposalCreateModal,
}: BidProposalListComponentProps) {
  const columns: ColumnsType<BidProposal> = [
    // {
    //   title: '업체명',
    //   dataIndex: ['user', 'myEnterprise', 'name'],
    // },
    // {
    //   title: '제출자명',
    //   render: (text: any, record: any, index: any) =>
    //     record.user === null
    //       ? `${record.userData.name}(${phoneFormatter(
    //           record.userData.personalPhone,
    //           1,
    //         )})`
    //       : `${record.user.name}(${phoneFormatter(
    //           record.user.personalPhone,
    //           1,
    //         )})`,
    // },
    {
      title: '금액',
      dataIndex: 'amount',
      width: '30%',
      render: (value: any, record: any, index: any) => priceToString(value),
    },
    {
      title: '상세내역',
      width: '40%',
      render: (text, record: any, index) => (
        <Space size="middle">
          {record.file.map((file: any, index: any) => (
            <li key={file.id}>
              <Link
                onClick={(e) => {
                  e.stopPropagation();
                  downloadFile(file.id, file.name);
                }}
              >
                {file.name}
              </Link>
            </li>
          ))}
        </Space>
      ),
    },
    {
      title: '제출일시',
      dataIndex: 'createdAt',
      width: '30%',
      render: (text: any, record: any, index: any) =>
        moment(record.createdAt).format('YYYY-MM-DD HH:mm:ss'),
    },
  ];

  return (
    <StyledDiv>
      <Row justify="space-between">
        <Col>
          <h3>제출 금액</h3>
        </Col>
        <Col>
          <Button size="small" onClick={openBidProposalCreateModal}>
            대신 제출
          </Button>
        </Col>
      </Row>
      <Table<BidProposal>
        rowKey="id"
        columns={columns}
        dataSource={bidProposals}
        pagination={false}
      />
    </StyledDiv>
  );
}

export default BidProposalListComponent;
